define.alias("shared/components/shared/ui/ember-drop", "calendar/components/shared/ui/ember-drop");